import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

export default function PendingAccessPage() {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(d => d.length >= 3 ? '' : d + '.');
    }, 600);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-amber-50 border border-amber-200 flex items-center justify-center mx-auto mb-6">
          <Clock size={32} className="text-amber-500" />
        </div>

        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-7 h-7 rounded-lg bg-blue-600 flex items-center justify-center shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
            </svg>
          </div>
          <span className="text-slate-900 font-bold text-lg tracking-tight">Okebourne</span>
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-3">Access Requested</h1>
        <p className="text-slate-500 text-sm leading-relaxed mb-6">
          Your sign-in was successful, but your account is awaiting admin approval.
          You'll be able to access Okebourne once an admin reviews your request.
        </p>

        <div className="bg-white border border-slate-200 rounded-xl px-6 py-4 mb-8 shadow-sm">
          <p className="text-slate-700 text-sm">Waiting for approval<span className="text-amber-500">{dots}</span></p>
        </div>

        <p className="text-slate-400 text-xs">
          If you believe this is a mistake, contact your administrator directly.
        </p>

        <button
          onClick={() => window.location.href = '/login'}
          className="mt-6 text-xs text-slate-400 hover:text-slate-600 transition-colors underline underline-offset-2"
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
}